// src/lib/theme/index.ts
// ============================================================================
// THE DECK COMPASS: THEME SYSTEM
// Central export point for all theme tokens
// ============================================================================

export { colors } from './colors';
export { typography } from './typography';
export { tokens } from './tokens';
export { shadows } from './shadows';

// Combine into single theme object for convenience
import { colors } from './colors';
import { typography } from './typography';
import { tokens } from './tokens';
import { shadows } from './shadows';

export const theme = {
  colors,
  typography,
  tokens,
  shadows,
} as const;

export type Theme = typeof theme;